import tiersTypes from "./tiers.types";
export default {
  addTierLoading: state => state.type === tiersTypes.ADD_TIER_REQUEST,
  addTierSuccess: state => state.type === tiersTypes.ADD_TIER_SUCCESS,
  addTierFailed: state => state.type === tiersTypes.ADD_TIER_FAILED,

  fetchTiersLoading: state => state.type === tiersTypes.FETCH_TIERS_REQUEST,
  fetchTiersSuccess: state => state.type === tiersTypes.FETCH_TIERS_SUCCESS,
  fetchTiersFailed: state => state.type === tiersTypes.FETCH_TIERS_FAILED,

  updateTierLoading: state => state.type === tiersTypes.UPDATE_TIER_REQUEST,
  updateTierSuccess: state => state.type === tiersTypes.UPDATE_TIER_SUCCESS,
  updateTierFailed: state => state.type === tiersTypes.UPDATE_TIER_FAILED,

  deleteTierLoading: state => state.type === tiersTypes.DELETE_TIER_REQUEST,
  deleteTierSuccess: state => state.type === tiersTypes.DELETE_TIER_SUCCESS,
  deleteTierFailed: state => state.type === tiersTypes.DELETE_TIER_FAILED
};
